import type { FC } from 'react';
import React, { memo, useContext, Fragment } from 'react';

import { ContextPanel } from '@atlaskit/editor-core';

import { fg } from '@confluence/feature-gating';

import { EditorContextPanelContext } from './EditorContextPanelContext';
import { Heading } from './CommonPanelElements/Heading';

export const EditorContextPanelView: FC = memo(() => {
	const { item: contextPanelItem, editorAPI } = useContext(EditorContextPanelContext);

	let component;
	let onClose;
	let closeLabel;
	let closeAutoFocus;
	let hasPadding;
	let customWidth;

	if (contextPanelItem) {
		component = contextPanelItem.component;
		onClose = contextPanelItem.close;
		closeLabel = contextPanelItem.closeLabel;
		closeAutoFocus = contextPanelItem.closeAutoFocus;
		hasPadding = contextPanelItem.hasPadding;
		customWidth = contextPanelItem.customWidth;
	}

	// Remove after company_hub_config_panel_refinement is rolled out
	const isComments = contextPanelItem?.itemName === 'object-sidebar-panel';

	return (
		<ContextPanel
			visible={!!contextPanelItem}
			editorAPI={editorAPI ?? undefined}
			hasPadding={hasPadding}
			customWidth={customWidth}
		>
			<Fragment>
				{!!component && !fg('company_hub_config_panel_refinement') && !isComments && (
					<Heading onClose={onClose} closeLabel={closeLabel} closeAutoFocus={closeAutoFocus} />
				)}
				{component}
			</Fragment>
		</ContextPanel>
	);
});
